module.exports = __webpack_public_path__ + "img/photo-34.fa5c4575.png";